import { WebPlugin } from '@capacitor/core';
export class LinkrunnerWeb extends WebPlugin {
    async init(options) {
        console.warn('Linkrunner: init is not available on web platform', options);
    }
    async signup(options) {
        console.warn('Linkrunner: signup is not available on web platform', options);
    }
    async setUserData(options) {
        console.warn('Linkrunner: setUserData is not available on web platform', options);
    }
    async capturePayment(options) {
        console.warn('Linkrunner: capturePayment is not available on web platform', options);
    }
    async removePayment(options) {
        console.warn('Linkrunner: removePayment is not available on web platform', options);
    }
    async trackEvent(options) {
        console.warn('Linkrunner: trackEvent is not available on web platform', options);
    }
    async getAttributionData() {
        console.warn('Linkrunner: getAttributionData is not available on web platform');
        return { data: {} };
    }
    async setAdditionalData(options) {
        console.warn('Linkrunner: setAdditionalData is not available on web platform', options);
    }
    async enablePIIHashing(options) {
        console.warn('Linkrunner: enablePIIHashing is not available on web platform', options);
    }
    async setPushToken(options) {
        console.warn('Linkrunner: setPushToken is not available on web platform', options);
    }
    async setCustomerUserId(options) {
        console.warn('Linkrunner: setCustomerUserId is not available on web platform', options);
    }
    async handleDeeplink(options) {
        console.warn('Linkrunner: handleDeeplink is not available on web platform', options);
        return {};
    }
    async getPackageVersion() {
        console.warn('Linkrunner: getPackageVersion is not available on web platform');
        return { version: '0.0.0' };
    }
}
//# sourceMappingURL=web.js.map